export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
};

export type ActivityStatusChangedInput = {
  activityType: ActivityType;
  trigger: ActivityTrigger;
};

export type ActivityStatusChangedResponse = {
  __typename?: "ActivityStatusChangedResponse";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Whether the activity is starting or ending */
export enum ActivityTrigger {
  end = "END",
  start = "START",
}

/** The type of activity being tracked */
export enum ActivityType {
  break = "BREAK",
  delivery_check_in = "DELIVERY_CHECK_IN",
  inbounding = "INBOUNDING",
  inventory_checks = "INVENTORY_CHECKS",
  picking = "PICKING",
  rescue_bag = "RESCUE_BAG",
  restocking = "RESTOCKING",
}

export type AddProductsToInboundingListInput = {
  listId: Scalars["ID"]["input"];
  products: Array<InboundingListProductInput>;
};

export type AddProductsToInboundingListResponse = {
  __typename?: "AddProductsToInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type Asset = {
  __typename?: "Asset";
  createdAt: Scalars["String"]["output"];
  hubCode: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  model?: Maybe<ModelCompact>;
  serialNumber: Scalars["String"]["output"];
  state: AssetState;
  supplier?: Maybe<SupplierCompact>;
  updatedAt: Scalars["String"]["output"];
};

export enum AssetState {
  asset_state_defect = "ASSET_STATE_DEFECT",
  asset_state_in_repair = "ASSET_STATE_IN_REPAIR",
  asset_state_in_transit = "ASSET_STATE_IN_TRANSIT",
  asset_state_lost = "ASSET_STATE_LOST",
  asset_state_operational = "ASSET_STATE_OPERATIONAL",
  asset_state_outbounded = "ASSET_STATE_OUTBOUNDED",
  asset_state_partially_operational = "ASSET_STATE_PARTIALLY_OPERATIONAL",
  asset_state_stolen = "ASSET_STATE_STOLEN",
  asset_state_unspecified = "ASSET_STATE_UNSPECIFIED",
}

export enum AssetTypes {
  bike_battery = "BIKE_BATTERY",
}

export type BatchUpdateStockForSkuInput = {
  sku: Scalars["String"]["input"];
  stockUpdates: Array<StockUpdate>;
};

export type BatchUpdateStockForSkuResponse = {
  __typename?: "BatchUpdateStockForSkuResponse";
  success: Scalars["Boolean"]["output"];
};

export type CategoryV2 = {
  __typename?: "CategoryV2";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  subcategories: Array<SubcategoryV2>;
};

export type CheckFilters = {
  metadataReason?: InputMaybe<Array<TaskMetadataReason>>;
  priority?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  type?: InputMaybe<Array<TaskType>>;
};

export type CheckMutationResponse = {
  __typename?: "CheckMutationResponse";
  success: Scalars["Boolean"]["output"];
};

export enum CheckStatus {
  canceled = "CANCELED",
  done = "DONE",
  in_progress = "IN_PROGRESS",
  open = "OPEN",
  skipped = "SKIPPED",
  unfulfillable = "UNFULFILLABLE",
}

export type ClaimInboundingListInput = {
  listId: Scalars["ID"]["input"];
};

export type ClaimInboundingListResponse = {
  __typename?: "ClaimInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type CloudinarySignature = {
  __typename?: "CloudinarySignature";
  apiKey: Scalars["String"]["output"];
  cloudName: Scalars["String"]["output"];
  publicId?: Maybe<Scalars["String"]["output"]>;
  signature: Scalars["String"]["output"];
  timestamp: Scalars["Float"]["output"];
};

export enum CommonInboundingListStatus {
  inbounding_list_status_claimed = "INBOUNDING_LIST_STATUS_CLAIMED",
  inbounding_list_status_completed = "INBOUNDING_LIST_STATUS_COMPLETED",
  inbounding_list_status_draft = "INBOUNDING_LIST_STATUS_DRAFT",
  inbounding_list_status_unclaimed = "INBOUNDING_LIST_STATUS_UNCLAIMED",
  inbounding_list_status_unspecified = "INBOUNDING_LIST_STATUS_UNSPECIFIED",
}

export enum CommonInboundingType {
  inbounding_type_bakery = "INBOUNDING_TYPE_BAKERY",
  inbounding_type_lekkerland = "INBOUNDING_TYPE_LEKKERLAND",
  inbounding_type_not_delivery = "INBOUNDING_TYPE_NOT_DELIVERY",
  inbounding_type_other_delivery = "INBOUNDING_TYPE_OTHER_DELIVERY",
  inbounding_type_rewe = "INBOUNDING_TYPE_REWE",
  inbounding_type_unspecified = "INBOUNDING_TYPE_UNSPECIFIED",
}

export enum CommonListType {
  list_type_cancelled_order = "LIST_TYPE_CANCELLED_ORDER",
  list_type_regular = "LIST_TYPE_REGULAR",
  list_type_unspecified = "LIST_TYPE_UNSPECIFIED",
}

export type CountryOfOrigin = {
  __typename?: "CountryOfOrigin";
  code?: Maybe<Scalars["String"]["output"]>;
};

export type CreateAssetInput = {
  modelId: Scalars["String"]["input"];
  serialNumber: Scalars["String"]["input"];
  supplierId: Scalars["String"]["input"];
};

export type CreateAssetResponse = {
  __typename?: "CreateAssetResponse";
  asset: Asset;
};

export type CreateCheckInput = {
  metadataReason: TaskMetadataReason;
  priority: Scalars["Int"]["input"];
  shelfNumber: Scalars["String"]["input"];
  sku: Scalars["String"]["input"];
  type: TaskType;
};

export type CreateInboundingListInput = {
  inboundingType?: InputMaybe<CommonInboundingType>;
  name: Scalars["String"]["input"];
  sscc?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateInboundingListResponse = {
  __typename?: "CreateInboundingListResponse";
  id: Scalars["ID"]["output"];
};

export type CreatePrivateRestockingListInput = {
  skus: Array<Scalars["String"]["input"]>;
};

export type CustomAttributes = {
  __typename?: "CustomAttributes";
  desadv?: Maybe<Scalars["String"]["output"]>;
  expectedQuantity?: Maybe<Scalars["Int"]["output"]>;
  sscc?: Maybe<Scalars["String"]["output"]>;
};

export type DamageReport = {
  __typename?: "DamageReport";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  status: ReportStatus;
  type: DamageType;
};

export type DamageReportAsset = {
  __typename?: "DamageReportAsset";
  assetId: Scalars["String"]["output"];
  state: AssetState;
};

export type DamageReportInput = {
  assetId: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  type: DamageType;
};

export type DamageReportResponse = {
  __typename?: "DamageReportResponse";
  asset: DamageReportAsset;
  damageReport: DamageReport;
};

export enum DamageType {
  damage_type_handle_broken = "DAMAGE_TYPE_HANDLE_BROKEN",
  damage_type_identifier_missing = "DAMAGE_TYPE_IDENTIFIER_MISSING",
  damage_type_key_stuck = "DAMAGE_TYPE_KEY_STUCK",
  damage_type_low_battery_capacity = "DAMAGE_TYPE_LOW_BATTERY_CAPACITY",
  damage_type_not_charging = "DAMAGE_TYPE_NOT_CHARGING",
  damage_type_physical_damage = "DAMAGE_TYPE_PHYSICAL_DAMAGE",
}

export type DeleteImageInput = {
  publicId: Scalars["String"]["input"];
};

export type DeleteImageResult = {
  __typename?: "DeleteImageResult";
  success: Scalars["Boolean"]["output"];
};

export type DeleteInboundingListInput = {
  listId: Scalars["ID"]["input"];
};

export type DeleteInboundingListProductsInput = {
  listId: Scalars["ID"]["input"];
  skus: Array<Scalars["String"]["input"]>;
};

export type DeleteInboundingListProductsResponse = {
  __typename?: "DeleteInboundingListProductsResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeleteInboundingListResponse = {
  __typename?: "DeleteInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeletePrivateListResponse = {
  __typename?: "DeletePrivateListResponse";
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type DeliverTransportEquipmentCountInput = {
  billNumber: Scalars["String"]["input"];
  dateOfPickup: Scalars["String"]["input"];
  deliveryImageUrls: Array<Scalars["String"]["input"]>;
  externalSupplierId: Scalars["ID"]["input"];
  lineItems: Array<TransportEquipmentLineItemInput>;
  transportEquipmentCountId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DeliverTransportEquipmentCountPayload = {
  __typename?: "DeliverTransportEquipmentCountPayload";
  success: Scalars["Boolean"]["output"];
};

export enum DeliveryCheckinProductCategory {
  drinks = "DRINKS",
  dry = "DRY",
  fresh = "FRESH",
  frozen = "FROZEN",
}

export type DeliveryCheckinResponse = {
  __typename?: "DeliveryCheckinResponse";
  deliveryCheckin: IDeliveryCheckin;
};

export type DeliveryCheckinResponseV2 = {
  __typename?: "DeliveryCheckinResponseV2";
  deliveryCheckin: IDeliveryCheckinV2;
};

export type DeliveryRolliV2 = {
  desadvId?: InputMaybe<Scalars["String"]["input"]>;
  expectedHubSlug?: InputMaybe<Scalars["String"]["input"]>;
  sscc: Scalars["String"]["input"];
  status: Scalars["String"]["input"];
};

export type DespatchAdvice = {
  __typename?: "DespatchAdvice";
  expectedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  items: Array<DespatchAdviceItem>;
};

export type DespatchAdviceDeliveriesForHub = {
  __typename?: "DespatchAdviceDeliveriesForHub";
  estimatedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  ssccs: Array<Scalars["String"]["output"]>;
};

export type DespatchAdviceItem = {
  __typename?: "DespatchAdviceItem";
  handlingUnitSize: Scalars["Int"]["output"];
  isTotalQuantityEstimate: Scalars["Boolean"]["output"];
  skus: Array<Scalars["String"]["output"]>;
  totalQuantity: Scalars["Int"]["output"];
};

export type DeviceClaim = {
  __typename?: "DeviceClaim";
  deviceId?: Maybe<Scalars["String"]["output"]>;
  employeeId: Scalars["ID"]["output"];
  hubSlug: Scalars["String"]["output"];
};

export type DeviceClaimInput = {
  employeeId: Scalars["String"]["input"];
};

export type EditInboundingListInput = {
  listId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type EditInboundingListResponse = {
  __typename?: "EditInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type EditProductsInInboundingListInput = {
  listId: Scalars["ID"]["input"];
  products: Array<InboundingListProductInput>;
};

export type EditProductsInInboundingListResponse = {
  __typename?: "EditProductsInInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type EmployeeInfo = {
  __typename?: "EmployeeInfo";
  displayName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
};

export type EquipmentType = {
  __typename?: "EquipmentType";
  createdAt: Scalars["DateTime"]["output"];
  depositInEuros?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  photoUrl: Scalars["String"]["output"];
};

export type FinishRecurrentTaskInput = {
  count: Scalars["Int"]["input"];
  recurrentTaskId: Scalars["String"]["input"];
};

export type FinishRecurrentTaskResponse = {
  __typename?: "FinishRecurrentTaskResponse";
  success: Scalars["Boolean"]["output"];
};

export type GenerateSignatureInput = {
  folder: Scalars["String"]["input"];
  publicId?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetActiveEquipmentTypesForSupplierPayload = {
  __typename?: "GetActiveEquipmentTypesForSupplierPayload";
  equipmentTypes: Array<EquipmentType>;
};

export type GetAssetByIdInput = {
  assetId: Scalars["String"]["input"];
};

export type GetAssetByIdResponse = {
  __typename?: "GetAssetByIdResponse";
  asset?: Maybe<Asset>;
};

export type GetAssetsByHubInput = {
  assetType?: InputMaybe<AssetTypes>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<Array<AssetState>>;
};

export type GetAssetsByHubResponse = {
  __typename?: "GetAssetsByHubResponse";
  assets: Array<Asset>;
  pagination: PaginationInfo;
};

export type GetClaimedProducts = {
  __typename?: "GetClaimedProducts";
  bio?: Maybe<Scalars["Boolean"]["output"]>;
  countryOfOrigin?: Maybe<CountryOfOrigin>;
  handlingUnitSize: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  inventoryEntry: InventoryEntry;
  isInbounded?: Maybe<Scalars["Boolean"]["output"]>;
  isShelvedInHandlingUnits?: Maybe<Scalars["Boolean"]["output"]>;
  minDaysToBestBeforeDate?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  numberOfShelfFacings?: Maybe<Scalars["Int"]["output"]>;
  numberOfShelfStackings?: Maybe<Scalars["Int"]["output"]>;
  quantity: Scalars["Int"]["output"];
  sku: Scalars["String"]["output"];
  status?: Maybe<ListProductStatus>;
  units?: Maybe<Array<Unit>>;
};

export type GetDeliveryCheckinsResponse = {
  __typename?: "GetDeliveryCheckinsResponse";
  deliveryCheckins: Array<IDeliveryCheckin>;
};

export type GetDeliveryCheckinsResponseV2 = {
  __typename?: "GetDeliveryCheckinsResponseV2";
  deliveryCheckins: Array<IDeliveryCheckinV2>;
};

export type GetDespatchAdviceByRolliIdInput = {
  rolliID: Scalars["String"]["input"];
};

export type GetDespatchAdviceByRolliIdResponse = {
  __typename?: "GetDespatchAdviceByRolliIDResponse";
  despatchAdvice: DespatchAdvice;
};

export type GetDespatchAdviceDeliveriesForHubResponse = {
  __typename?: "GetDespatchAdviceDeliveriesForHubResponse";
  despatchAdviceDeliveriesForHub: Array<DespatchAdviceDeliveriesForHub>;
};

export type GetDespatchAdviceSummaryByRolliIdInput = {
  rolliID: Scalars["String"]["input"];
};

export type GetDespatchAdviceSummaryByRolliIdResponse = {
  __typename?: "GetDespatchAdviceSummaryByRolliIDResponse";
  despatchAdviceSummary: DespatchAdvice;
};

export type GetEmployeesInput = {
  badgeNumbers: Array<Scalars["String"]["input"]>;
};

export type GetHubStockChangeLogsInput = {
  sku: Scalars["String"]["input"];
};

export type GetHubStockChangeLogsResponse = {
  __typename?: "GetHubStockChangeLogsResponse";
  stockChangeLogs: Array<StockChangeLog>;
};

export type GetInboundingListClaimersInput = {
  listId: Scalars["ID"]["input"];
};

export type GetInboundingListClaimersResponse = {
  __typename?: "GetInboundingListClaimersResponse";
  claimerIds?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GetInboundingListStatsInput = {
  status: Array<CommonInboundingListStatus>;
  type: Array<CommonListType>;
};

export type GetInboundingListStatsResponse = {
  __typename?: "GetInboundingListStatsResponse";
  stats?: Maybe<Array<InboundingListStat>>;
};

export type GetInboundingListsInput = {
  status: Array<InboundingListStatus>;
};

export type GetInboundingListsResponse = {
  __typename?: "GetInboundingListsResponse";
  lists?: Maybe<Array<InboundingList>>;
};

export type GetInventoryEntriesByShelfInput = {
  shelfNumber: Scalars["String"]["input"];
};

export type GetInventoryEntriesByShelfResponse = {
  __typename?: "GetInventoryEntriesByShelfResponse";
  inventoryEntries: Array<InventoryEntry>;
};

export type GetListClaimedProductsResponse = {
  __typename?: "GetListClaimedProductsResponse";
  claimerIds?: Maybe<Array<Scalars["String"]["output"]>>;
  creatorId?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  inboundingType: CommonInboundingType;
  listType: CommonListType;
  name?: Maybe<Scalars["String"]["output"]>;
  orderId?: Maybe<Scalars["String"]["output"]>;
  products: Array<GetClaimedProducts>;
  sscc?: Maybe<Scalars["String"]["output"]>;
};

export type GetModelsInput = {
  assetType?: InputMaybe<AssetTypes>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  supplierId?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetModelsResponse = {
  __typename?: "GetModelsResponse";
  models: Array<Model>;
  pagination: PaginationInfo;
};

export type GetMultipleDesadvsRolliIdInput = {
  rolliID: Scalars["String"]["input"];
};

export type GetMultipleDesadvsRolliIdResponse = {
  __typename?: "GetMultipleDesadvsRolliIDResponse";
  despatchAdvices: Array<MultipleDesadv>;
};

export type GetNextCheckForHubResponse = {
  __typename?: "GetNextCheckForHubResponse";
  check?: Maybe<ICheck>;
  /** @deprecated Use GetOpenedChecksCountForHub instead */
  pendingChecksCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GetNextCheckForShelfInput = {
  filters?: InputMaybe<CheckFilters>;
  shelfNumber: Scalars["String"]["input"];
};

export type GetNextCheckForShelfResponse = {
  __typename?: "GetNextCheckForShelfResponse";
  check?: Maybe<ICheck>;
};

export type GetOpenedChecksCountForHubResponse = {
  __typename?: "GetOpenedChecksCountForHubResponse";
  pendingChecksCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GetOrderInput = {
  orderId: Scalars["String"]["input"];
};

export type GetOrderResponse = {
  __typename?: "GetOrderResponse";
  order: Order;
};

export type GetPendingChecksResponse = {
  __typename?: "GetPendingChecksResponse";
  checks: Array<ICheck>;
};

export type GetProductInput = {
  sku: Scalars["ID"]["input"];
};

export type GetProductsBySubcategoryInput = {
  subcategoryId: Scalars["String"]["input"];
};

export type GetProductsBySubcategoryResponse = {
  __typename?: "GetProductsBySubcategoryResponse";
  products: Array<IProduct>;
};

export type GetProductsInput = {
  skus: Array<Scalars["ID"]["input"]>;
};

export type GetProductsResponse = {
  __typename?: "GetProductsResponse";
  products: Array<IProduct>;
};

export type GetPublicRestockingListResponse = {
  __typename?: "GetPublicRestockingListResponse";
  publicRestockingList: PublicRestockingList;
};

export type GetRecurrentTasksInput = {
  type?: InputMaybe<RecurrentTaskType>;
};

export type GetRecurrentTasksResponse = {
  __typename?: "GetRecurrentTasksResponse";
  recurrentTasks: Array<RecurrentTask>;
};

export type GetShelfChangeProposalsResponse = {
  __typename?: "GetShelfChangeProposalsResponse";
  proposals: Array<ShelfChangeProposalItem>;
};

export type GetSuppliersForHubResponse = {
  __typename?: "GetSuppliersForHubResponse";
  suppliers: Array<ISupplier>;
};

export type GetTaskByIdInput = {
  taskId: Scalars["ID"]["input"];
};

export type GetTaskByIdResponse = {
  __typename?: "GetTaskByIdResponse";
  task?: Maybe<ICheck>;
};

export type GetTransportEquipmentCountsPayload = {
  __typename?: "GetTransportEquipmentCountsPayload";
  transportEquipmentCounts: Array<TransportEquipmentCount>;
};

export type HandoverDetails = {
  __typename?: "HandoverDetails";
  containerIds?: Maybe<Array<Scalars["String"]["output"]>>;
  shelfNumbers?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type HubOneEmployee = {
  __typename?: "HubOneEmployee";
  badgeNo: Scalars["ID"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  hubs: Array<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  roles: Array<Scalars["String"]["output"]>;
};

export type ICheck = {
  __typename?: "ICheck";
  customAttributes?: Maybe<CustomAttributes>;
  id: Scalars["ID"]["output"];
  priority: Scalars["Int"]["output"];
  product?: Maybe<IProduct>;
  productSku: Scalars["String"]["output"];
  shelfNumber: Scalars["String"]["output"];
  status: CheckStatus;
  type: TaskType;
};

export type ICheckProductArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IDeliveryCheckin = {
  __typename?: "IDeliveryCheckin";
  categories?: Maybe<Array<DeliveryCheckinProductCategory>>;
  /** Timestamp in ISO 8601 format. Example: 2023-02-06T13:33:44+00:00 */
  created_at: Scalars["String"]["output"];
  /** Timestamp in ISO 8601 format. Example: 2023-02-06T13:33:44+00:00 */
  delivered_at: Scalars["String"]["output"];
  hub_slug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  supplier: ISupplierSummary;
};

export type IDeliveryCheckinV2 = {
  __typename?: "IDeliveryCheckinV2";
  /** Timestamp in ISO 8601 format. Example: 2023-02-06T13:33:44+00:00 */
  createdAt: Scalars["String"]["output"];
  /** Timestamp in ISO 8601 format. Example: 2023-02-06T13:33:44+00:00 */
  deliveredAt: Scalars["String"]["output"];
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  numberOfAcceptedRollies: Scalars["Int"]["output"];
  supplier: ISupplierSummary;
};

export type IProduct = {
  __typename?: "IProduct";
  bbd?: Maybe<Scalars["String"]["output"]>;
  bio?: Maybe<Scalars["Boolean"]["output"]>;
  countryOfOrigin: CountryOfOrigin;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  inventoryEntry: InventoryEntry;
  isShelvedInHandlingUnits?: Maybe<Scalars["Boolean"]["output"]>;
  minDaysToBestBeforeDate?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  numberOfShelfFacings?: Maybe<Scalars["Int"]["output"]>;
  numberOfShelfStackings?: Maybe<Scalars["Int"]["output"]>;
  price?: Maybe<Scalars["Float"]["output"]>;
  productClassification?: Maybe<Array<Scalars["String"]["output"]>>;
  sku: Scalars["ID"]["output"];
  smartPickingAlert?: Maybe<SmartPickingAlert>;
  units: Array<Unit>;
};

export type IProductUnitsArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ISupplier = {
  __typename?: "ISupplier";
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  sortSequence: Scalars["Int"]["output"];
};

export type ISupplierSummary = {
  __typename?: "ISupplierSummary";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InboundProductInput = {
  productId: Scalars["String"]["input"];
};

export type InboundProductResponse = {
  __typename?: "InboundProductResponse";
  success: Scalars["Boolean"]["output"];
};

export type InboundingList = {
  __typename?: "InboundingList";
  claimerIds?: Maybe<Array<Scalars["String"]["output"]>>;
  createdAt: Scalars["String"]["output"];
  creatorId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inboundingType: CommonInboundingType;
  listType: CommonListType;
  name: Scalars["String"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  products?: Maybe<Array<InboundingListProduct>>;
  sscc: Scalars["String"]["output"];
  status: InboundingListStatus;
};

export type InboundingListProduct = {
  __typename?: "InboundingListProduct";
  handlingUnitSize: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isInbounded?: Maybe<Scalars["Boolean"]["output"]>;
  quantity: Scalars["Int"]["output"];
  sku: Scalars["String"]["output"];
  status?: Maybe<ListProductStatus>;
};

export type InboundingListProductInput = {
  handlingUnitSize: Scalars["Int"]["input"];
  metadata?: InputMaybe<InboundingListProductMetadataInput>;
  quantity: Scalars["Int"]["input"];
  sku: Scalars["String"]["input"];
};

export type InboundingListProductMetadataInput = {
  desadv?: InputMaybe<Scalars["String"]["input"]>;
  expectedQuantity?: InputMaybe<Scalars["String"]["input"]>;
  inboundingMethod?: InputMaybe<Scalars["String"]["input"]>;
  inboundingUnit?: InputMaybe<Scalars["String"]["input"]>;
  scannedEan?: InputMaybe<Scalars["String"]["input"]>;
  sscc?: InputMaybe<Scalars["String"]["input"]>;
};

export type InboundingListStat = {
  __typename?: "InboundingListStat";
  count?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export enum InboundingListStatus {
  inbounding_list_status_claimed = "INBOUNDING_LIST_STATUS_CLAIMED",
  inbounding_list_status_completed = "INBOUNDING_LIST_STATUS_COMPLETED",
  inbounding_list_status_draft = "INBOUNDING_LIST_STATUS_DRAFT",
  inbounding_list_status_unclaimed = "INBOUNDING_LIST_STATUS_UNCLAIMED",
  inbounding_list_status_unspecified = "INBOUNDING_LIST_STATUS_UNSPECIFIED",
}

export type InventoryChangeMetadata = {
  additionalOutboundReason?: InputMaybe<Scalars["String"]["input"]>;
  desadv?: InputMaybe<Scalars["String"]["input"]>;
  expectedQuantity?: InputMaybe<Scalars["String"]["input"]>;
  expirationDate?: InputMaybe<Scalars["String"]["input"]>;
  imageUrls?: InputMaybe<Scalars["String"]["input"]>;
  inboundingMethod?: InputMaybe<Scalars["String"]["input"]>;
  inboundingUnit?: InputMaybe<Scalars["String"]["input"]>;
  lotNumber?: InputMaybe<Scalars["String"]["input"]>;
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  scannedEAN?: InputMaybe<Scalars["String"]["input"]>;
  sscc?: InputMaybe<Scalars["String"]["input"]>;
  stockCorrectionId?: InputMaybe<Scalars["String"]["input"]>;
};

export enum InventoryChangeReason {
  correction = "CORRECTION",
  correction_baking_ingredients = "CORRECTION_BAKING_INGREDIENTS",
  correction_break_in = "CORRECTION_BREAK_IN",
  correction_order_cancellation_return = "CORRECTION_ORDER_CANCELLATION_RETURN",
  eoy_inventory_check = "EOY_INVENTORY_CHECK",
  eoy_inventory_recount = "EOY_INVENTORY_RECOUNT",
  extra_check = "EXTRA_CHECK",
  inbound_bulk = "INBOUND_BULK",
  inbound_goods_received = "INBOUND_GOODS_RECEIVED",
  inbound_order_cancellation = "INBOUND_ORDER_CANCELLATION",
  inbound_stock_transfer = "INBOUND_STOCK_TRANSFER",
  inbound_surprise_bag = "INBOUND_SURPRISE_BAG",
  low_stock_check = "LOW_STOCK_CHECK",
  order_cancelled = "ORDER_CANCELLED",
  order_created = "ORDER_CREATED",
  outbound_delivery_product_damaged = "OUTBOUND_DELIVERY_PRODUCT_DAMAGED",
  outbound_delivery_product_expired = "OUTBOUND_DELIVERY_PRODUCT_EXPIRED",
  outbound_equipment_failure = "OUTBOUND_EQUIPMENT_FAILURE",
  outbound_hub_closure = "OUTBOUND_HUB_CLOSURE",
  outbound_order_cancellation_not_returned = "OUTBOUND_ORDER_CANCELLATION_NOT_RETURNED",
  outbound_order_cancellation_not_sellable = "OUTBOUND_ORDER_CANCELLATION_NOT_SELLABLE",
  outbound_product_damaged = "OUTBOUND_PRODUCT_DAMAGED",
  outbound_product_expired = "OUTBOUND_PRODUCT_EXPIRED",
  outbound_stock_transfer = "OUTBOUND_STOCK_TRANSFER",
  outbound_surprise_bag = "OUTBOUND_SURPRISE_BAG",
  outbound_too_good_to_go = "OUTBOUND_TOO_GOOD_TO_GO",
  out_of_stock_check = "OUT_OF_STOCK_CHECK",
  post_inbound_correction = "POST_INBOUND_CORRECTION",
  product_recall = "PRODUCT_RECALL",
  requested_from_inbound_correction = "REQUESTED_FROM_INBOUND_CORRECTION",
  rolling_inventory_check = "ROLLING_INVENTORY_CHECK",
  unspecified = "UNSPECIFIED",
}

export type InventoryEntry = {
  __typename?: "InventoryEntry";
  hubSlug: Scalars["ID"]["output"];
  product?: Maybe<IProduct>;
  productSku: Scalars["ID"]["output"];
  shelfNumber?: Maybe<Scalars["String"]["output"]>;
  stock?: Maybe<Stock>;
};

export type InventoryEntryProductArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Item = {
  __typename?: "Item";
  id: Scalars["ID"]["output"];
  product?: Maybe<IProduct>;
  quantity?: Maybe<Scalars["Float"]["output"]>;
  sku?: Maybe<Scalars["String"]["output"]>;
};

export type ItemProductArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ListProductStatus {
  list_product_status_claimed = "LIST_PRODUCT_STATUS_CLAIMED",
  list_product_status_inbounded = "LIST_PRODUCT_STATUS_INBOUNDED",
  list_product_status_unclaimed = "LIST_PRODUCT_STATUS_UNCLAIMED",
  list_product_status_unspecified = "LIST_PRODUCT_STATUS_UNSPECIFIED",
}

export enum MatchType {
  ean = "ean",
  name = "name",
  sku = "sku",
}

export type MissingItem = {
  quantity: Scalars["Float"]["input"];
  sku: Scalars["String"]["input"];
};

export type Model = {
  __typename?: "Model";
  modelId: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  supplier: ModelSupplier;
};

export type ModelCompact = {
  __typename?: "ModelCompact";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ModelSupplier = {
  __typename?: "ModelSupplier";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type MultipleDesadv = {
  __typename?: "MultipleDesadv";
  expectedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  hubSlug?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  items: Array<DespatchAdviceItem>;
};

export type Mutation = {
  __typename?: "Mutation";
  addProductsToInboundingList: AddProductsToInboundingListResponse;
  batchUpdateStockForSku: BatchUpdateStockForSkuResponse;
  claimDevice: DeviceClaim;
  claimInboundingList: ClaimInboundingListResponse;
  createAsset: CreateAssetResponse;
  createCheck: CheckMutationResponse;
  createDeliveryCheckinForHub: DeliveryCheckinResponse;
  createDeliveryCheckinForHubV2: DeliveryCheckinResponseV2;
  createInboundingList: CreateInboundingListResponse;
  createPrivateRestockingList: PrivateRestockingListResponse;
  damageReport: DamageReportResponse;
  deleteCloudinaryImage: DeleteImageResult;
  deleteInboundingList: DeleteInboundingListResponse;
  deleteInboundingListProducts: DeleteInboundingListProductsResponse;
  deletePrivateRestockingList: DeletePrivateListResponse;
  deleteSkuFromPrivateList: RestockingMutationResponse;
  deliverTransportEquipmentCount: DeliverTransportEquipmentCountPayload;
  editInboundingList: EditInboundingListResponse;
  editProductsInInboundingList: EditProductsInInboundingListResponse;
  endPicking: MutationResponse;
  finishPickingOrder: MutationResponse;
  finishRecurrentTask: FinishRecurrentTaskResponse;
  /** Finish a shelf change proposal */
  finishShelfChangeProposal: ShelfChangeProposalActionResponse;
  forceClaimDevice: DeviceClaim;
  generateCloudinarySignature: CloudinarySignature;
  identifyEmployee: HubOneEmployee;
  inboundProduct: InboundProductResponse;
  publishActivityStatusChanged: ActivityStatusChangedResponse;
  releaseInboundingList: ReleaseInboundingListResponse;
  removeItemFromRestockingPrivateList: RestockingMutationResponse;
  removeMultipleSkusFromRestockingPrivateList: RestockingMutationResponse;
  resetAllFlagsCache: Scalars["Boolean"]["output"];
  resetCacheForSpecificFlag: Scalars["Boolean"]["output"];
  restockItem: RestockingMutationResponse;
  saveSkuToPublicRestockingList: SaveSkuToPublicRestockingListResponse;
  saveTransportEquipmentCount: SaveTransportEquipmentCountPayload;
  shareInboundingList: ShareInboundingListResponse;
  startCheck: CheckMutationResponse;
  startManualPickingV2: StartPickingResponse;
  startPickingOrder: StartPickingOrderResponse;
  startPickingV2: StartPickingResponse;
  /** Start working on a shelf change proposal */
  startShelfChangeProposal: ShelfChangeProposalActionResponse;
  transferAsset: TransferAssetResponse;
  unclaimDevice: MutationResponse;
  updateAssetState: UpdateAssetStateResponse;
  updateProductBBD: CheckMutationResponse;
  updateProductStockByDeltaAndMultipleReasons: UpdateProductStockByDeltaAndMultipleReasonsResponse;
  updateSurpriseBagStock: UpdateSurpriseBagStockResponse;
  validateBBDCheck: CheckMutationResponse;
  validateEoyCheck: CheckMutationResponse;
  validateFreshnessCheck: CheckMutationResponse;
  validateStockCheck: CheckMutationResponse;
};

export type MutationAddProductsToInboundingListArgs = {
  input: AddProductsToInboundingListInput;
};

export type MutationBatchUpdateStockForSkuArgs = {
  UpdateProductStockByDeltaAndMultipleReasonsInput: BatchUpdateStockForSkuInput;
};

export type MutationClaimDeviceArgs = {
  input: DeviceClaimInput;
};

export type MutationClaimInboundingListArgs = {
  input: ClaimInboundingListInput;
};

export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};

export type MutationCreateCheckArgs = {
  input: CreateCheckInput;
};

export type MutationCreateDeliveryCheckinForHubArgs = {
  input: NewDeliveryCheckinInput;
};

export type MutationCreateDeliveryCheckinForHubV2Args = {
  input: NewDeliveryCheckinInputV2;
};

export type MutationCreateInboundingListArgs = {
  input: CreateInboundingListInput;
};

export type MutationCreatePrivateRestockingListArgs = {
  input: CreatePrivateRestockingListInput;
};

export type MutationDamageReportArgs = {
  input: DamageReportInput;
};

export type MutationDeleteCloudinaryImageArgs = {
  input: DeleteImageInput;
};

export type MutationDeleteInboundingListArgs = {
  input: DeleteInboundingListInput;
};

export type MutationDeleteInboundingListProductsArgs = {
  input: DeleteInboundingListProductsInput;
};

export type MutationDeletePrivateRestockingListArgs = {
  input: PrivateListIdInput;
};

export type MutationDeleteSkuFromPrivateListArgs = {
  input: RestockItemWithSkuAndListIdInput;
};

export type MutationDeliverTransportEquipmentCountArgs = {
  input: DeliverTransportEquipmentCountInput;
};

export type MutationEditInboundingListArgs = {
  input: EditInboundingListInput;
};

export type MutationEditProductsInInboundingListArgs = {
  input: EditProductsInInboundingListInput;
};

export type MutationEndPickingArgs = {
  containersIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  missingItems: Array<MissingItem>;
  orderNumber: Scalars["String"]["input"];
  shelvesIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  variablePrices?: InputMaybe<Array<VariablePriceInput>>;
};

export type MutationFinishPickingOrderArgs = {
  containerIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  missingItems?: InputMaybe<Array<MissingItem>>;
  orderId: Scalars["String"]["input"];
  shelfNumbers?: InputMaybe<Array<Scalars["String"]["input"]>>;
  variablePrices?: InputMaybe<Array<VariablePriceInput>>;
};

export type MutationFinishRecurrentTaskArgs = {
  input: FinishRecurrentTaskInput;
};

export type MutationFinishShelfChangeProposalArgs = {
  proposalId: Scalars["String"]["input"];
};

export type MutationForceClaimDeviceArgs = {
  input: DeviceClaimInput;
};

export type MutationGenerateCloudinarySignatureArgs = {
  input: GenerateSignatureInput;
};

export type MutationIdentifyEmployeeArgs = {
  badgeNo: Scalars["String"]["input"];
};

export type MutationInboundProductArgs = {
  input: InboundProductInput;
};

export type MutationPublishActivityStatusChangedArgs = {
  input: ActivityStatusChangedInput;
};

export type MutationReleaseInboundingListArgs = {
  input: ReleaseInboundingListInput;
};

export type MutationRemoveItemFromRestockingPrivateListArgs = {
  input: RestockItemWithSkuAndListIdInput;
};

export type MutationRemoveMultipleSkusFromRestockingPrivateListArgs = {
  input: RestockItemWithSkUsAndListIdInput;
};

export type MutationResetCacheForSpecificFlagArgs = {
  featureFlag: Scalars["String"]["input"];
  hubSlug: Scalars["String"]["input"];
};

export type MutationRestockItemArgs = {
  input: RestockItemWithSkuAndListIdInput;
};

export type MutationSaveSkuToPublicRestockingListArgs = {
  input: RestockingItemInput;
};

export type MutationSaveTransportEquipmentCountArgs = {
  input: SaveTransportEquipmentCountInput;
};

export type MutationShareInboundingListArgs = {
  input: ShareInboundingListInput;
};

export type MutationStartCheckArgs = {
  input: StartCheckInput;
};

export type MutationStartManualPickingV2Args = {
  orderNumber: Scalars["String"]["input"];
};

export type MutationStartPickingOrderArgs = {
  manualPicking?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["String"]["input"];
};

export type MutationStartPickingV2Args = {
  orderNumber: Scalars["String"]["input"];
};

export type MutationStartShelfChangeProposalArgs = {
  proposalId: Scalars["String"]["input"];
};

export type MutationTransferAssetArgs = {
  input: TransferAssetInput;
};

export type MutationUnclaimDeviceArgs = {
  input: DeviceClaimInput;
};

export type MutationUpdateAssetStateArgs = {
  input: UpdateAssetStateInput;
};

export type MutationUpdateProductBbdArgs = {
  input: UpdateProductBbdInput;
};

export type MutationUpdateProductStockByDeltaAndMultipleReasonsArgs = {
  UpdateProductStockByDeltaAndMultipleReasonsInput: UpdateProductStockByDeltaAndMultipleReasonsInput;
};

export type MutationUpdateSurpriseBagStockArgs = {
  updateSurpriseBagStockInput: UpdateSurpriseBagStockInput;
};

export type MutationValidateBbdCheckArgs = {
  input: ValidateBbdCheckInput;
};

export type MutationValidateEoyCheckArgs = {
  input: ValidateEoyCheckInput;
};

export type MutationValidateFreshnessCheckArgs = {
  input: ValidateFreshnessCheckInput;
};

export type MutationValidateStockCheckArgs = {
  input: ValidateStockCheckInput;
};

export type MutationResponse = {
  __typename?: "MutationResponse";
  message: Scalars["String"]["output"];
};

export type NewDeliveryCheckinInput = {
  categories: Array<Scalars["String"]["input"]>;
  delivered_at: Scalars["String"]["input"];
  supplier_id: Scalars["String"]["input"];
};

export type NewDeliveryCheckinInputV2 = {
  deliveredAt: Scalars["String"]["input"];
  deliveryRollies?: InputMaybe<Array<DeliveryRolliV2>>;
  supplierId: Scalars["String"]["input"];
};

export type NextOrderToBePreparedResponse = {
  __typename?: "NextOrderToBePreparedResponse";
  order?: Maybe<Order>;
};

export type NonScannableCategoriesV2Response = {
  __typename?: "NonScannableCategoriesV2Response";
  categories: Array<CategoryV2>;
};

export type OpenShelfChangeProposalsCount = {
  __typename?: "OpenShelfChangeProposalsCount";
  count: Scalars["Int"]["output"];
};

export type Order = {
  __typename?: "Order";
  ageVerification: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  finishedBy?: Maybe<Scalars["String"]["output"]>;
  handoverContainerIds?: Maybe<Array<Scalars["String"]["output"]>>;
  handoverShelfNumbers?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["ID"]["output"];
  isClickAndCollect: Scalars["Boolean"]["output"];
  isInStore: Scalars["Boolean"]["output"];
  isNewCustomer: Scalars["Boolean"]["output"];
  items: Array<Maybe<Item>>;
  number?: Maybe<Scalars["String"]["output"]>;
  pickingItemCount: Scalars["Int"]["output"];
  pickingState?: Maybe<Scalars["String"]["output"]>;
  reseller: Scalars["String"]["output"];
  startedBy?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  weight: Scalars["Int"]["output"];
};

export type OrderDetails = {
  __typename?: "OrderDetails";
  ageVerification: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  deliveryTag?: Maybe<Scalars["String"]["output"]>;
  externalDeliveryProvider?: Maybe<Scalars["String"]["output"]>;
  handoverIdentifier?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isClickAndCollect: Scalars["Boolean"]["output"];
  isInStore: Scalars["Boolean"]["output"];
  isNewCustomer: Scalars["Boolean"]["output"];
  items: Array<Maybe<Item>>;
  number?: Maybe<Scalars["String"]["output"]>;
  pickingDetails?: Maybe<PickingDetails>;
  pickingItemCount: Scalars["Int"]["output"];
  reseller: Scalars["String"]["output"];
  state?: Maybe<Scalars["String"]["output"]>;
  weight: Scalars["Int"]["output"];
};

export type OrderSummary = {
  __typename?: "OrderSummary";
  externalProvider?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isNewCustomer?: Maybe<Scalars["Boolean"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
};

export type PaginationInfo = {
  __typename?: "PaginationInfo";
  limit: Scalars["Int"]["output"];
  page: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type PickingDetails = {
  __typename?: "PickingDetails";
  finishedBy?: Maybe<EmployeeInfo>;
  handoverDetails?: Maybe<HandoverDetails>;
  pickingState?: Maybe<Scalars["String"]["output"]>;
  startedBy?: Maybe<EmployeeInfo>;
};

export type PickingOrderResponse = {
  __typename?: "PickingOrderResponse";
  isInPool?: Maybe<Scalars["Boolean"]["output"]>;
  orderSummary?: Maybe<PickingOrderSummary>;
};

export type PickingOrderSummary = {
  __typename?: "PickingOrderSummary";
  id: Scalars["ID"]["output"];
  number?: Maybe<Scalars["String"]["output"]>;
};

export type PrivateListIdInput = {
  privateListId: Scalars["String"]["input"];
};

export type PrivateRestockingListResponse = {
  __typename?: "PrivateRestockingListResponse";
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  opsAssociateId: Scalars["String"]["output"];
  restockingItems: Array<RestockingItem>;
};

export type ProductInput = {
  quantity: Scalars["Float"]["input"];
  sku: Scalars["String"]["input"];
};

export type ProductStockUpdateParams = {
  desadv?: InputMaybe<Scalars["String"]["input"]>;
  expectedQuantity?: InputMaybe<Scalars["String"]["input"]>;
  inboundingMethod?: InputMaybe<Scalars["String"]["input"]>;
  inboundingUnit?: InputMaybe<Scalars["String"]["input"]>;
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  quantityDelta: Scalars["Int"]["input"];
  reason: InventoryChangeReason;
  scannedEAN?: InputMaybe<Scalars["String"]["input"]>;
  sscc?: InputMaybe<Scalars["String"]["input"]>;
  stockCorrectionId?: InputMaybe<Scalars["String"]["input"]>;
  transactionId: Scalars["String"]["input"];
};

export type PublicRestockingList = {
  __typename?: "PublicRestockingList";
  hubSlug: Scalars["String"]["output"];
  restockingItems: Array<RestockingItem>;
};

export type Query = {
  __typename?: "Query";
  getActiveEquipmentTypesForSupplier: GetActiveEquipmentTypesForSupplierPayload;
  getAssetById: GetAssetByIdResponse;
  getAssetsByHub: GetAssetsByHubResponse;
  getDeliveryCheckInsForHubDeliveredToday: GetDeliveryCheckinsResponse;
  getDeliveryCheckInsForHubDeliveredTodayV2: GetDeliveryCheckinsResponseV2;
  getDespatchAdviceByRolliID: GetDespatchAdviceByRolliIdResponse;
  getDespatchAdviceDeliveriesForHub: GetDespatchAdviceDeliveriesForHubResponse;
  getDespatchAdviceSummaryByRolliID: GetDespatchAdviceSummaryByRolliIdResponse;
  getEmployees: Array<HubOneEmployee>;
  getHubStockChangeLogs: GetHubStockChangeLogsResponse;
  getInboundingListClaimers: GetInboundingListClaimersResponse;
  getInboundingListStats: GetInboundingListStatsResponse;
  getInboundingLists: GetInboundingListsResponse;
  getInventoryEntriesByShelf: GetInventoryEntriesByShelfResponse;
  getModels: GetModelsResponse;
  getMultipleDesadvsRolliID: GetMultipleDesadvsRolliIdResponse;
  getNextCheckForHub: GetNextCheckForHubResponse;
  getNextCheckForShelf: GetNextCheckForShelfResponse;
  getNonScannableCategories: NonScannableCategoriesV2Response;
  /** Get count of open shelf change proposals for a hub */
  getOpenShelfChangeProposalsCount: OpenShelfChangeProposalsCount;
  getOpenedChecksCountForHub: GetOpenedChecksCountForHubResponse;
  getOrder: GetOrderResponse;
  getOrderDetails: OrderDetails;
  getOrderForPicking: PickingOrderResponse;
  getPendingChecks: GetPendingChecksResponse;
  getPrivateRestockingList: PrivateRestockingListResponse;
  getProduct: IProduct;
  getProducts: GetProductsResponse;
  getProductsBySubcategoryV2: GetProductsBySubcategoryResponse;
  getProductsFromClaimedList: GetListClaimedProductsResponse;
  getPublicRestockingList: GetPublicRestockingListResponse;
  getRecurrentTasksForHub: GetRecurrentTasksResponse;
  /** Get a single shelf change proposal by ID */
  getShelfChangeProposalById: ShelfChangeProposalItem;
  /** List shelf change proposals for a hub */
  getShelfChangeProposals: GetShelfChangeProposalsResponse;
  getSummaryOfNextOrderToPick: SummaryOfNextOrderToPickResponse;
  getSuppliersForHub: GetSuppliersForHubResponse;
  getTaskById: GetTaskByIdResponse;
  getTransportEquipmentCounts: GetTransportEquipmentCountsPayload;
  nextOrderForPicking: NextOrderToBePreparedResponse;
  searchAssets: SearchAssetsResponse;
  searchUnitsByEan: SearchUnitsByEanResponse;
  searchUnitsByText: SearchUnitsByTextResponse;
};

export type QueryGetActiveEquipmentTypesForSupplierArgs = {
  externalSupplierId: Scalars["ID"]["input"];
};

export type QueryGetAssetByIdArgs = {
  input: GetAssetByIdInput;
};

export type QueryGetAssetsByHubArgs = {
  input?: InputMaybe<GetAssetsByHubInput>;
};

export type QueryGetDespatchAdviceByRolliIdArgs = {
  GetDespatchAdviceByRolliIDInput: GetDespatchAdviceByRolliIdInput;
};

export type QueryGetDespatchAdviceSummaryByRolliIdArgs = {
  GetDespatchAdviceSummaryByRolliIDInput: GetDespatchAdviceSummaryByRolliIdInput;
};

export type QueryGetEmployeesArgs = {
  input: GetEmployeesInput;
};

export type QueryGetHubStockChangeLogsArgs = {
  input: GetHubStockChangeLogsInput;
};

export type QueryGetInboundingListClaimersArgs = {
  input: GetInboundingListClaimersInput;
};

export type QueryGetInboundingListStatsArgs = {
  input: GetInboundingListStatsInput;
};

export type QueryGetInboundingListsArgs = {
  input?: InputMaybe<GetInboundingListsInput>;
};

export type QueryGetInventoryEntriesByShelfArgs = {
  input: GetInventoryEntriesByShelfInput;
};

export type QueryGetModelsArgs = {
  input?: InputMaybe<GetModelsInput>;
};

export type QueryGetMultipleDesadvsRolliIdArgs = {
  GetMultipleDesadvsRolliIDInput: GetMultipleDesadvsRolliIdInput;
};

export type QueryGetNextCheckForShelfArgs = {
  input: GetNextCheckForShelfInput;
};

export type QueryGetOpenedChecksCountForHubArgs = {
  input?: InputMaybe<CheckFilters>;
};

export type QueryGetOrderArgs = {
  input: GetOrderInput;
};

export type QueryGetOrderDetailsArgs = {
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  orderNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetPendingChecksArgs = {
  input?: InputMaybe<CheckFilters>;
};

export type QueryGetProductArgs = {
  input: GetProductInput;
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetProductsArgs = {
  input: GetProductsInput;
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetProductsBySubcategoryV2Args = {
  input: GetProductsBySubcategoryInput;
};

export type QueryGetRecurrentTasksForHubArgs = {
  input?: InputMaybe<GetRecurrentTasksInput>;
};

export type QueryGetShelfChangeProposalByIdArgs = {
  proposalId: Scalars["String"]["input"];
};

export type QueryGetShelfChangeProposalsArgs = {
  shelfOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetTaskByIdArgs = {
  input: GetTaskByIdInput;
};

export type QueryGetTransportEquipmentCountsArgs = {
  externalSupplierId: Scalars["ID"]["input"];
  status: TransportEquipmentCountStatus;
};

export type QuerySearchAssetsArgs = {
  input?: InputMaybe<SearchAssetsInput>;
};

export type QuerySearchUnitsByEanArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchUnitsByEanInput: SearchUnitsByEanInput;
};

export type QuerySearchUnitsByTextArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchUnitsByTextInput: SearchUnitsByTextInput;
};

export type RecurrentTask = {
  __typename?: "RecurrentTask";
  createdAt: Scalars["String"]["output"];
  customAttributes: RecurrentTaskCustomAttributes;
  dueDate: Scalars["String"]["output"];
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  startDate: Scalars["String"]["output"];
  status: RecurrentTaskStatus;
  type: RecurrentTaskType;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  updatedBy?: Maybe<Scalars["String"]["output"]>;
};

export type RecurrentTaskCustomAttributes = {
  __typename?: "RecurrentTaskCustomAttributes";
  count: Scalars["Int"]["output"];
};

export enum RecurrentTaskStatus {
  done = "DONE",
  open = "OPEN",
}

export enum RecurrentTaskType {
  bike_battery_count = "BIKE_BATTERY_COUNT",
}

export type ReleaseInboundingListInput = {
  listId: Scalars["ID"]["input"];
};

export type ReleaseInboundingListResponse = {
  __typename?: "ReleaseInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export enum ReportStatus {
  report_status_open = "REPORT_STATUS_OPEN",
}

export type RestockItemWithSkuAndListIdInput = {
  listId: Scalars["String"]["input"];
  sku: Scalars["String"]["input"];
};

export type RestockItemWithSkUsAndListIdInput = {
  listId: Scalars["String"]["input"];
  skus: Array<Scalars["String"]["input"]>;
};

export type RestockingItem = {
  __typename?: "RestockingItem";
  hubSlug: Scalars["String"]["output"];
  priorityTier?: Maybe<RestockingPriorityTier>;
  privateListId?: Maybe<Scalars["String"]["output"]>;
  product?: Maybe<IProduct>;
  sku: Scalars["String"]["output"];
  status: RestockingItemStatus;
};

export type RestockingItemInput = {
  sku: Scalars["String"]["input"];
  source?: InputMaybe<RestockingSource>;
};

export enum RestockingItemStatus {
  done = "DONE",
  new = "NEW",
}

export type RestockingMutationResponse = {
  __typename?: "RestockingMutationResponse";
  message: Scalars["String"]["output"];
};

export enum RestockingPriorityTier {
  high = "HIGH",
  low = "LOW",
  medium = "MEDIUM",
}

export enum RestockingSource {
  manual = "MANUAL",
  picking = "PICKING",
}

export type SaveSkuToPublicRestockingListResponse = {
  __typename?: "SaveSkuToPublicRestockingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type SaveTransportEquipmentCountInput = {
  externalSupplierId: Scalars["ID"]["input"];
  lineItems: Array<TransportEquipmentLineItemInput>;
};

export type SaveTransportEquipmentCountPayload = {
  __typename?: "SaveTransportEquipmentCountPayload";
  success: Scalars["Boolean"]["output"];
};

export type SearchAssetsInput = {
  assetType?: InputMaybe<AssetTypes>;
  hubCode?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  modelId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  serialNumber?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<AssetState>;
  supplierId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchAssetsResponse = {
  __typename?: "SearchAssetsResponse";
  assets: Array<Asset>;
  pagination: PaginationInfo;
};

export type SearchUnitsByEanInput = {
  ean: Scalars["String"]["input"];
};

export type SearchUnitsByEanResponse = {
  __typename?: "SearchUnitsByEanResponse";
  units: Array<Unit>;
};

export type SearchUnitsByTextInput = {
  query: Scalars["String"]["input"];
};

export type SearchUnitsByTextResponse = {
  __typename?: "SearchUnitsByTextResponse";
  matchType?: Maybe<MatchType>;
  units: Array<Unit>;
};

export type ShareInboundingListInput = {
  listId: Scalars["ID"]["input"];
};

export type ShareInboundingListResponse = {
  __typename?: "ShareInboundingListResponse";
  success: Scalars["Boolean"]["output"];
};

export type ShelfChangeProposalActionResponse = {
  __typename?: "ShelfChangeProposalActionResponse";
  success: Scalars["Boolean"]["output"];
};

export type ShelfChangeProposalItem = {
  __typename?: "ShelfChangeProposalItem";
  availableUntilDate: Scalars["String"]["output"];
  dueDate: Scalars["String"]["output"];
  hubSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  product?: Maybe<IProduct>;
  productName?: Maybe<Scalars["String"]["output"]>;
  proposalDate: Scalars["String"]["output"];
  shelfFrom?: Maybe<Scalars["String"]["output"]>;
  shelfTo?: Maybe<Scalars["String"]["output"]>;
  sku: Scalars["String"]["output"];
  status: ShelfChangeStatus;
  updatedBy?: Maybe<Scalars["String"]["output"]>;
};

export enum ShelfChangeStatus {
  completed = "COMPLETED",
  open = "OPEN",
}

export type SmartPickingAlert = {
  __typename?: "SmartPickingAlert";
  issueType: SmartPickingIssueType;
};

export enum SmartPickingIssueType {
  damaged = "DAMAGED",
  expired = "EXPIRED",
  missing = "MISSING",
  wrong = "WRONG",
}

export type StartCheckInput = {
  checkId: Scalars["ID"]["input"];
};

export type StartPickingOrderResponse = {
  __typename?: "StartPickingOrderResponse";
  orderDetails?: Maybe<OrderDetails>;
};

export type StartPickingResponse = {
  __typename?: "StartPickingResponse";
  deliveryTag?: Maybe<Scalars["String"]["output"]>;
  externalDeliveryProvider?: Maybe<Scalars["String"]["output"]>;
  handoverIdentifier?: Maybe<Scalars["String"]["output"]>;
  order?: Maybe<Order>;
};

export type Stock = {
  __typename?: "Stock";
  /** The stock available for clients */
  available: Scalars["Int"]["output"];
  /** The number of item already ordered but still on the shelf */
  reserved?: Maybe<Scalars["Int"]["output"]>;
  /** The real stock in the hub */
  shelf: Scalars["Int"]["output"];
};

export type StockChangeLog = {
  __typename?: "StockChangeLog";
  actor: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
  reason: Scalars["String"]["output"];
  triggeredAt: Scalars["String"]["output"];
};

export type StockUpdate = {
  metadata?: InputMaybe<InventoryChangeMetadata>;
  quantityDelta: Scalars["Int"]["input"];
  reason: InventoryChangeReason;
};

export type SubcategoryV2 = {
  __typename?: "SubcategoryV2";
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  productsCount: Scalars["Int"]["output"];
};

export type SummaryOfNextOrderToPickResponse = {
  __typename?: "SummaryOfNextOrderToPickResponse";
  isInPool?: Maybe<Scalars["Boolean"]["output"]>;
  orderSummary?: Maybe<OrderSummary>;
};

export type SupplierCompact = {
  __typename?: "SupplierCompact";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export enum TaskMetadataReason {
  bbd = "BBD",
  bbd_missing = "BBD_MISSING",
  dropping = "DROPPING",
  eoy_inventory = "EOY_INVENTORY",
  eoy_inventory_recount = "EOY_INVENTORY_RECOUNT",
  expensive = "EXPENSIVE",
  extra = "EXTRA",
  freshness = "FRESHNESS",
  inventory_discrepancy = "INVENTORY_DISCREPANCY",
  low_stock = "LOW_STOCK",
  missing = "MISSING",
  rolling_8_weeks = "ROLLING_8_WEEKS",
  rolling_12_weeks = "ROLLING_12_WEEKS",
  rolling_inventory = "ROLLING_INVENTORY",
  spontaneous_correction = "SPONTANEOUS_CORRECTION",
  tobacco = "TOBACCO",
}

export enum TaskType {
  bbd_check = "BBD_CHECK",
  eoy_inventory_check = "EOY_INVENTORY_CHECK",
  eoy_inventory_recount_check = "EOY_INVENTORY_RECOUNT_CHECK",
  freshness_check = "FRESHNESS_CHECK",
  inventory_discrepancy_check = "INVENTORY_DISCREPANCY_CHECK",
  stock_check = "STOCK_CHECK",
}

export type TransferAssetInput = {
  assetId: Scalars["String"]["input"];
  fromHubCode: Scalars["String"]["input"];
};

export type TransferAssetResponse = {
  __typename?: "TransferAssetResponse";
  asset: Asset;
};

export type TransportEquipmentCount = {
  __typename?: "TransportEquipmentCount";
  actor?: Maybe<Scalars["String"]["output"]>;
  billNumber?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dateOfPickup?: Maybe<Scalars["String"]["output"]>;
  deliveryImageUrls: Array<Scalars["String"]["output"]>;
  externalSupplierId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  lineItems: Array<TransportEquipmentLineItem>;
  status: TransportEquipmentCountStatus;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum TransportEquipmentCountStatus {
  delivered = "DELIVERED",
  pending = "PENDING",
}

export type TransportEquipmentLineItem = {
  __typename?: "TransportEquipmentLineItem";
  depositInEuros?: Maybe<Scalars["Float"]["output"]>;
  equipmentTypeId: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  photoUrl: Scalars["String"]["output"];
  received?: Maybe<Scalars["Int"]["output"]>;
  returned: Scalars["Int"]["output"];
};

export type TransportEquipmentLineItemInput = {
  equipmentTypeId: Scalars["ID"]["input"];
  received: Scalars["Int"]["input"];
  returned: Scalars["Int"]["input"];
};

export type Unit = {
  __typename?: "Unit";
  ean?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  product: IProduct;
  productSku: Scalars["ID"]["output"];
  quantity: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
  variablePriceCode?: Maybe<Scalars["String"]["output"]>;
};

export type UnitProductArgs = {
  isAlwaysInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateAssetStateInput = {
  assetId: Scalars["String"]["input"];
  newState: AssetState;
};

export type UpdateAssetStateResponse = {
  __typename?: "UpdateAssetStateResponse";
  asset: Asset;
};

export type UpdateProductBbdInput = {
  closestBBDAfterOutbound: Scalars["String"]["input"];
  sku: Scalars["String"]["input"];
};

export type UpdateProductStockByDeltaAndMultipleReasonsInput = {
  sku: Scalars["String"]["input"];
  stockUpdates: Array<ProductStockUpdateParams>;
};

export type UpdateProductStockByDeltaAndMultipleReasonsResponse = {
  __typename?: "UpdateProductStockByDeltaAndMultipleReasonsResponse";
  updateResults: Array<UpdateProductStockByDeltaResponse>;
};

export type UpdateProductStockByDeltaResponse = {
  __typename?: "UpdateProductStockByDeltaResponse";
  success: Scalars["Boolean"]["output"];
  transactionId: Scalars["String"]["output"];
};

export type UpdateSurpriseBagStockInput = {
  products?: InputMaybe<Array<ProductInput>>;
  reason: InventoryChangeReason;
  sku: Scalars["String"]["input"];
  transactionId: Scalars["String"]["input"];
};

export type UpdateSurpriseBagStockResponse = {
  __typename?: "UpdateSurpriseBagStockResponse";
  success: Scalars["Boolean"]["output"];
};

export type ValidateBbdCheckInput = {
  checkId: Scalars["ID"]["input"];
  closestBBDAfterOutbound?: InputMaybe<Scalars["String"]["input"]>;
  quantityExpired?: InputMaybe<Scalars["Int"]["input"]>;
  quantityTooGoodToGo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ValidateEoyCheckInput = {
  checkId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  type: TaskType;
};

export type ValidateFreshnessCheckInput = {
  checkId: Scalars["ID"]["input"];
  quantityDamaged?: InputMaybe<Scalars["Int"]["input"]>;
  quantityExpired?: InputMaybe<Scalars["Int"]["input"]>;
  quantityTooGoodToGo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ValidateStockCheckInput = {
  checkId: Scalars["ID"]["input"];
  /** This is the final counted stock, after removing damaged and perished */
  quantity: Scalars["Int"]["input"];
  quantityDamaged?: InputMaybe<Scalars["Int"]["input"]>;
  quantityExpired?: InputMaybe<Scalars["Int"]["input"]>;
  quantityTooGoodToGo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VariablePriceInput = {
  price: Scalars["Int"]["input"];
  sku: Scalars["String"]["input"];
};
